import {
  Paper,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { useState, MouseEvent } from "react";

interface TdCountTogglesProps {
  activeCount: number;
  archiveCount: number;
  onClick: (_archived: boolean) => void;
}
type ToggleOptions = "active" | "archived";

const TdCountToggles = ({
  activeCount,
  archiveCount,
  onClick,
}: TdCountTogglesProps) => {
  const [buttonState, setButtonState] = useState<ToggleOptions>("active");
  const handleChange = (_e: MouseEvent, newValue: ToggleOptions) => {
    setButtonState(newValue);
    onClick(newValue === "archived");
  };

  return (
    <ToggleButtonGroup
      exclusive
      onChange={handleChange}
      value={buttonState}
      sx={{ gap: 3, p: 1 }}
    >
      <CountBox value="active" count={activeCount} label="Active" />
      <CountBox value="archived" count={archiveCount} label="Archived" />
    </ToggleButtonGroup>
  );
};

interface CountBoxProps {
  label: string;
  count: number;
  value: string;
}

const CountBox = ({ label, count, value }: CountBoxProps) => {
  return (
    <Paper elevation={3}>
      <ToggleButton
        value={value}
        sx={{
          color: "primary.main",
          width: "100px",
          height: "90px",
          display: "block",

          "&.Mui-selected": {
            backgroundColor: "primary.main",
            color: "primary.contrastText",
          },
          "&.Mui-selected:hover": {
            backgroundColor: "primary.main",
          },
          "&:hover": {
            border: "solid 1px",
          },
        }}
      >
        <Typography variant="h3">{count}</Typography>
        <Typography variant="body1" fontSize={14}>
          {label}
        </Typography>
      </ToggleButton>
    </Paper>
  );
};

export default TdCountToggles;
